import { CurrencyPipe, DatePipe, NgFor } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { FormsModule } from "@angular/forms";
import { RoteiroCrossdocking } from '../shared/interface/generic-interface';
import { Util } from '../shared/Util';
import { GraphicService } from '../shared/graphic.service';
import { LoadedModules } from '../shared/esri-load-control.service';
import { State } from '../shared/control-status.service';

@Component({
  selector: 'box-roteiros-crossdocking',
  standalone: true,
  imports: [FormsModule, NgFor, DatePipe, CurrencyPipe],
  templateUrl: './box-roteiros-crossdocking.component.html',
  styleUrl: './box-roteiros-crossdocking.component.css'
})
export class BoxRoteirosCrossdockingComponent implements OnInit {
  @Input() dados: any;
  roteirosCrossdocking: RoteiroCrossdocking[] = [];

  constructor(private graphicService: GraphicService){}

  ngOnInit(): void {
    this.roteirosCrossdocking = this.dados.roteirosCrossdocking;
    this.criaCorRotaRoteiroCrossdocking();
    this.adicionaInfoRoteiroCrossdocking()
  }

  criaCorRotaRoteiroCrossdocking(){
    this.roteirosCrossdocking.forEach(item => {
       const corRota = Util.gerarHex();
      item.corRota = corRota;
    });
  }

  adicionaInfoRoteiroCrossdocking(){
    const result = JSON.parse(Util.decompress(this.dados.ResultRotaBinConvert));
    this.adicionaOrigemPontoDeApoio(result.stops);
    this.adicionaTrajetoriaRoteiroCrossdocking(result);
  }

  private adicionaTrajetoriaRoteiroCrossdocking(routeResults){
    let routeGraphic:any;
    const symbol = {
          join: 'round',
          type: 'simple-line',
          color: '#0C1114',
          width: '4px'
        }
    if(routeResults.newVersion){
      const geometria = routeResults.mergedGeometry;
      const geometry = LoadedModules.JsonUtils.fromJSON(geometria);
      routeGraphic= new LoadedModules.Graphic({
      geometry: geometry,
      symbol: symbol
    })}
    else{
     routeGraphic = new LoadedModules.Graphic({
        geometry:  routeResults.routeResults[0].directions.mergedGeometry,
        symbol: symbol
      });
    }
    this.graphicService.layers[State.visualizadorDeRoteiros].add(routeGraphic);
  }

  private adicionaOrigemPontoDeApoio(stops: any) {
    stops.forEach((stop,index)  => {
      const geometry = new LoadedModules.Point({
      latitude: stop.attributes.SnapY,
      longitude: stop.attributes.SnapX
    })
    const symbol = new LoadedModules.PictureMarkerSymbol
      ({
        "url": index == 0 ? 'assets/img/ultima_entrega_dist.svg' : 'assets/img/ponto-apoio-logistico.png',
        "height": 24,
        "width": 19.5,
      })
    const pontoApoioLogisticoGraphic = new LoadedModules.Graphic({
        geometry: geometry,
        symbol: symbol,
      })
    this.graphicService.layers[State.visualizadorLinhasPontos].add(pontoApoioLogisticoGraphic);
    }); 
  }

  layoutConteudoPopup(teste: string){
    return `<div>${teste}</div>`
  }
}
